import React from 'react';
import { Route, Switch } from 'react-router-dom';
import routes from '../../routes';

export default function AuthLayout() {
	function getRoutes(rotas) {
		return rotas.map((prop) => {
			if (prop.layout === '/auth') {
				if (prop.path === '/alterar-senha') {
					return (
						<Route
							path={`${prop.layout}${prop.path}/:token`}
							component={prop.component}
							key={prop.name}
						/>
					);
				}
				return (
					<Route
						path={`${prop.layout}${prop.path}`}
						component={prop.component}
						key={prop.name}
					/>
				);
			}
			return null;
		});
	}
	return (
		<Switch>
			<Route>{getRoutes(routes)}</Route>
		</Switch>
	);
}
